module.exports = "<app-head *ngIf=\"notLogin()\" class=\"header\"></app-head>\r\n<app-sidebar *ngIf=\"notLogin()\" class=\"sidebar\"></app-sidebar>\r\n<main [ngClass]=\"{'content' : notLogin(), 'login' : !notLogin()}\">\r\n   <router-outlet></router-outlet>\r\n\r\n</main>\r\n<!-- Modals> -->\r\n<app-loading-screen></app-loading-screen>\r\n<app-warnings></app-warnings>\r\n<app-player></app-player>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main